import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map,switchMap } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class AdminDailyStatsGetEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.dailyStats.getApi),
			switchMap((action) =>
				this.adminService.dailyStats(action.startDate, action.endDate).pipe(
					map((stats) => MpAdminActions.dailyStats.getSuccess({ stats, loading: false })),
					catchError((error) =>
						of(MpAdminActions.dailyStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private adminService: MpAdminService,
		private actions: Actions
	) {}
}
